import {LTServices} from "../../lt-ng/lt-services";
import IMapService = LTServices.IMapService;
import {IContextLayerQuery} from "./context-layer-query";
import {L} from "../../lt-ng/landcare-toolkit";
import Item = L.tree.Item;
import {KoordinatesLayerQuery} from "./koordinates-layer-query";
import {WFSLayerQuery} from "./wfs-layer-query";
import {PortalsServicesLayerQuery} from "./portals-layer-query";
import {IPortalServices} from "../../lt-ng/portal-services";

export function getContextQueryForLayer(theNode: Item, $http: ng.IHttpService, mapService: IMapService, portalService: IPortalServices) : IContextLayerQuery {
    let layerServce = theNode.layerService;

    if (layerServce.koordinatesLayer && layerServce.koordinatesLayer.forAreaQuery) {
        return new KoordinatesLayerQuery(theNode, $http, mapService);
    } else if (layerServce.WFSLayers.length && layerServce.WFSLayers.some(wfs => wfs.forAreaQuery)) {
        return new WFSLayerQuery(layerServce.WFSLayers[0], $http, mapService, layerServce.id);
    }

    if (layerServce.attributes && layerServce.attributes.PredefinedFeatureLayer) {
        return new PortalsServicesLayerQuery(layerServce, $http, mapService, portalService);
    }

    throw new Error("Layer has no context query information");
}
